module.exports = __webpack_public_path__ + "9fec9298c4d79e7526310d85f2db6efc.svg";